import {gql} from "@apollo/client";

export const GET_RANDOM_LEAD_POPS = gql`
    query {
        person {
            firstName
            lastName
            email
            phone
            creditProfile
            employmentStatus
            monthlyIncome
            annualIncome
            filedBankruptcy
            workingWithRealtor
        }
        property {
            value
            type
            used
            location {
                state
                zip
            }
            loan {
                purpose
                amount
                cashOut
                downPayment
            }
        }
    }
`;